





































import {Component, Vue} from "vue-property-decorator";
import BaseOverview, {Loadable} from "@/resources/components/BaseOverview.vue";
import Checklist from '@/app/models/Checklist';

@Component({
    components: {
        "base-overview": BaseOverview,
    },
})

export default class Index extends Vue {
    reopenChecklist(checklist: Checklist) {
        if (confirm(this.$t("Weet jij zeker dat je deze checklist wilt heropenen?") as string)) {
            checklist.reopen().then(() => (this.$refs.overview as BaseOverview).reset());
        }
    }

    async loadItems(loadable: Loadable) {
        loadable.loadItems(
            (await Checklist.index(loadable.page, {brand_id: this.$route.params.brand})).data
        );
    }
}
